
import PreEntryApi from '../../assets/js/preentry'
import Msg from 'vux/src/components/msg/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Popup from 'vux/src/components/popup/index.vue'

export default {
components: {

Msg,

Divider,
XButton,
XHeader,
Flexbox,
FlexboxItem,
Loading,

Popup
},
data () {
return {
id: '',
code: '',
showLoading: true,
name: '',
week: '',
adder: '',
join_type: '',
adder_info: '',
start_date: '',
bottom_title: '',
salary_email: '',
contact: '',
addr: '',
mobile: ''
}
},
created () {
this.id = this.$route.query.id
this.$forceUpdate()


var localStorage = window.localStorage
this.code = localStorage.getItem('pre_code')
if (!this.code || !this.id) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}

PreEntryApi.checkLogin(
{ id: this.id, code: this.code },
(data, meta) => {},
err => {
this.showLoading = false
if (err === -2) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
},
err => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
},
err => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
)

PreEntryApi.getOfferTemplateData({ id: this.id }, (data, meta) => {
if (data) {
this.name = data.name
this.week = data.week
this.adder = data.adder
this.join_type = data.join_type
this.adder_info = data.adder_info
this.start_date = data.start_date
this.bottom_title = data.bottom_title
this.salary_email = data.salary_email
this.contact = data.contact
this.addr = data.addr
this.mobile = data.mobile
}
})
},
mounted () {
this.showLoading = false
},
methods: {
downloadMedical () {
PreEntryApi.downloadMedical()
},

acceptOffer () {
this.$router.push({ name: 'onboard.material', query: { id: this.id } })
},
goPreView () {
this.$router.push({ name: 'onboard.material', query: { id: this.id } })
}
}
}



// WEBPACK FOOTER //
// ./src/components/onboard/info.vue